// components/common/confirm-dialog/esta-seguro.jsx
import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import './esta-seguro.css';

function EstaSeguro({ 
  visible, 
  onHide, 
  onConfirm, 
  titulo, 
  descripcion, 
  posicion = 'center',
  icon = 'pi pi-exclamation-triangle',
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  loading = false,
}) {

  const header = (
    <div className="es-header">
      <div className="es-header-icon">
        <i className={'pi pi-question'} />
      </div>
      <span className="es-header-title">{titulo}</span>
    </div>
  );

  const footer = (
    <div className="es-footer">
      <Button 
        label={cancelLabel}
        icon="pi pi-times" 
        onClick={onHide} 
        className="es-btn es-btn--cancel"
        disabled={loading}
      />
      <Button 
        label={confirmLabel}
        icon="pi pi-check" 
        onClick={onConfirm}
        className="es-btn es-btn--confirm"
        loading={loading}
        autoFocus
      />
    </div>
  );

  return (
    <Dialog 
      header={header}
      visible={visible} 
      position={posicion}
      style={{ width: '420px', margin: '20px'}} 
      onHide={onHide}
      footer={footer}
      draggable={false}
      resizable={false}
      className="es-dialog"
    >
      <div className="es-body-icon">
        <i className={icon}/>
      </div>
      <p className="es-description">{descripcion}</p>
    </Dialog>
  );
}

export default EstaSeguro;